// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContentUI_sections__UqH7E {\n  display: flex;\n  flex-wrap: wrap;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/contents/styles/ContentUI.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":[".sections {\n  display: flex;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sections": "ContentUI_sections__UqH7E"
};
export default ___CSS_LOADER_EXPORT___;
